"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCellEditable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _reactRedux = require("react-redux");
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _excluded = ["value", "type", "columnValue", "editable", "productId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    tableCell: {
      position: "relative",
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      "& p": {
        margin: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      "&:hover": {
        "& > span": {
          opacity: 1
        }
      }
    },
    editIcon: {
      opacity: 0,
      marginTop: "-5px",
      marginLeft: "4px",
      transition: "opacity 0.3s ease"
    }
  };
});
var TableCellEditable = function TableCellEditable(_ref) {
  var value = _ref.value,
    type = _ref.type,
    columnValue = _ref.columnValue,
    editable = _ref.editable,
    productId = _ref.productId,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    edit = _useState2[0],
    setEdit = _useState2[1];
  var inputRef = (0, _react.useRef)(null);
  var lastInputValue = (0, _react.useRef)(columnValue);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.ProductReducer;
    }),
    inProgress = _useSelector.inProgress;
  var classes = useStyles();
  (0, _react.useEffect)(function () {
    if (edit && inputRef.current) {
      inputRef.current.focus();
    }
  }, [edit]);
  var handleSubmitValue = function handleSubmitValue() {
    if (inputRef.current.value === "") return;
    var formData = new FormData();
    formData.append(value, inputRef.current.value);
    dispatch({
      type: "UPDATE_PRODUCT",
      endpoint: "salable-products",
      model: formData,
      id: productId,
      onSuccess: function onSuccess() {
        lastInputValue.current = inputRef.current.value;
        setEdit(false);
      }
    });
  };
  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
  };
  var handleCellClick = function handleCellClick() {
    setEdit(true);
  };
  var handleInputBlur = function handleInputBlur() {
    setEdit(false);
  };
  var handleInputKeyDown = function handleInputKeyDown(event) {
    if (event.key === "Enter") {
      handleSubmitValue();
    } else if (event.key === "Escape") {
      setEdit(false);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    className: props.classes.tableCell,
    key: value,
    title: lastInputValue.current,
    onClick: handleCellClick,
    style: {
      cursor: editable ? "pointer" : "auto"
    }
  }, edit ? /*#__PURE__*/_react.default.createElement(_core.TextField, {
    type: type,
    variant: "outlined",
    name: value,
    disabled: inProgress,
    onBlur: handleInputBlur,
    onKeyDown: handleInputKeyDown,
    inputRef: inputRef,
    defaultValue: lastInputValue.current,
    style: {
      minWidth: type === "string" ? "200px" : "auto"
    },
    fullWidth: true,
    InputProps: {
      endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "end"
      }, inProgress ? /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
        size: 28
      }) : /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: handleSubmitValue,
        onMouseDown: handleMouseDown
      }, /*#__PURE__*/_react.default.createElement(_Check.default, null)))
    }
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tableCell
  }, /*#__PURE__*/_react.default.createElement("p", null, lastInputValue.current), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.editIcon
  }, /*#__PURE__*/_react.default.createElement(_Edit.default, null))));
};
exports.TableCellEditable = TableCellEditable;